module.exports = __webpack_public_path__ + "assets/not_working.28c7d2692775fa779a4a5991f21cebe8.png";